var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunHorizonFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 20a1 1 0 01-1 1H2a1 1 0 010-2h5.056a9 9 0 1117.888 0H30a1 1 0 011 1zm-5 4H6a1 1 0 100 2h20a1 1 0 000-2zM10.105 7.447a1 1 0 001.79-.895l-1-2a1 1 0 00-1.79.895l1 2zm-7.553 5.448l2 1a1 1 0 00.896-1.79l-2-1a1 1 0 10-.895 1.79zM27 14c.155 0 .308-.036.446-.105l2-1a1 1 0 00-.895-1.79l-2 1A1 1 0 0027 14zm-6.448-6.105a1 1 0 001.343-.448l1-2a1 1 0 10-1.79-.895l-1 2a.998.998 0 00.447 1.343z"
  })));
}
export default SvgSunHorizonFill;